import { render, staticRenderFns } from "./find-account.vue?vue&type=template&id=1221850a&scoped=true"
import script from "./find-account.vue?vue&type=script&lang=js"
export * from "./find-account.vue?vue&type=script&lang=js"
import style0 from "./find-account.vue?vue&type=style&index=0&id=1221850a&prod&lang=css"
import style1 from "./find-account.vue?vue&type=style&index=1&id=1221850a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221850a",
  null
  
)

export default component.exports